import { DayOfWeek } from "projects/shared/lib/services/INTEGRA_Shop_Client";

export class DeliveryReminder {
  public day: DayOfWeek;
  public isSmsDay: boolean | undefined;
  public isMailDay: boolean | undefined;
  public isBothDay: boolean | undefined;


  constructor(data: DeliveryReminder) {
    this.day = data.day;
    this.isSmsDay = data.isSmsDay;
    this.isBothDay = data.isMailDay;
    this.isMailDay = data.isBothDay;
  }
}
